import React, { useState } from 'react';
import Title from '../components/Title';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqData = [
  {
    category: 'General',
    questions: [
      {
        q: 'Do you have an offline store?',
        a: 'No, we are an online-only brand and do not have any physical stores.',
      },
      {
        q: 'How do I find a product on the website?',
        a: 'You can browse through the categorized collections or use the search bar. If you need help, feel free to contact us via WhatsApp or email.',
      },
    ],
  },
  {
    category: 'Product',
    questions: [
      {
        q: 'Will the products be exactly like in the pictures?',
        a: 'All our jewellery pieces are handcrafted and may have slight variations in polish and finish. This uniqueness is the charm of handmade products, not a flaw.',
      },
      {
        q: 'Are Zarviya products skin-friendly?',
        a: 'Yes, all our products are made with skin-safe materials and are free from harsh chemicals.',
      },
      {
        q: 'How do I care for my jewellery?',
        a: 'Store in a dry place, away from moisture and perfumes. Wipe gently with a soft cloth after use. Do not expose to water or chemicals.',
      },
      {
        q: 'Is there a warranty on the products?',
        a: 'Currently, we do not offer warranties. However, we inspect all items before dispatch to ensure quality.',
      },
    ],
  },
  {
    category: 'Shipping',
    questions: [
      {
        q: 'What are the shipping charges?',
        a: 'Shipping charges depend on your location. We offer free shipping on prepaid orders above ₹499. International shipping rates vary based on destination and package weight.',
      },
      {
        q: 'How long does shipping take?',
        a: 'Domestic orders are dispatched within 2–3 working days and delivered in 4–7 days. International deliveries may take 10–15 business days.',
      },
      {
        q: 'Do you ship internationally?',
        a: 'Yes, we ship globally. International orders can be placed by contacting us via WhatsApp.',
      },
      {
        q: 'How can I track my order?',
        a: "You will receive a tracking link via SMS or email once your order is dispatched. You can also track it at <a href='https://zarviya.com/trackyourOrder' target='_blank' rel='noopener noreferrer' class='text-[#4c0f2e] underline'>Track Your Order</a>.",
      },
    ],
  },
  {
    category: 'Orders',
    questions: [
      {
        q: 'How do I know if my order is confirmed?',
        a: 'An order confirmation email will be sent to you upon successful purchase.',
      },
      {
        q: 'Can I cancel or change my order?',
        a: "Yes, if your order hasn't been shipped. Contact us at the earliest to request changes.",
      },
      {
        q: 'Can I add more items to an existing order?',
        a: 'Only if the order is not dispatched. Contact our support team for assistance.',
      },
      {
        q: 'Why did I receive only a part of my order?',
        a: 'Some items may be shipped separately. Please check your shipping details or reach out to us.',
      },
      {
        q: 'Can I update my address or phone number?',
        a: 'Yes, contact us immediately to request changes before dispatch.',
      },
      {
        q: 'What should I do if I placed duplicate orders?',
        a: 'Please get in touch with us quickly so we can cancel and refund the duplicate order.',
      },
    ],
  },
];

const Faq = () => {
  const [active, setActive] = useState(null);

  const toggle = (q) => {
    setActive(active === q ? null : q);
  };

  return (
    <div className="bg-[#fff9f7] min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <Title text1="Have Questions? " text2="We've Got Answers" />
          <p className="text-sm text-gray-600 mt-2">Explore the most common queries below</p>
        </div>

        {faqData.map((section, i) => (
          <div key={i} className="mb-10">
            <h3 className="text-lg font-semibold text-[#4b1e1e] mb-6 border-b border-[#d6c2ba] pb-2 uppercase tracking-wide">
              {section.category}
            </h3>
            <div className="space-y-4">
              {section.questions.map(({ q, a }, j) => (
                <div key={j} className="bg-[#fdf4f1] border border-[#e0c5bc] rounded-xl shadow-sm">
                  <button
                    className="w-full flex justify-between items-center px-5 py-4 font-medium text-left text-[#3d1d1a] hover:bg-[#fbeeee] focus:outline-none"
                    onClick={() => toggle(q)}
                  >
                    <span>{q}</span>
                    {active === q ? (
                      <FaMinus className="text-xs" />
                    ) : (
                      <FaPlus className="text-xs" />
                    )}
                  </button>
                  {active === q && (
                    <div
                      className="px-5 pb-5 text-sm text-gray-700"
                      dangerouslySetInnerHTML={{ __html: a }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
